import { AbstractControl, ValidationErrors } from '@angular/forms';

import { isSSNNotMatchLength } from '../../helpers/info-helper';

export const WOOLWORTH_SSN = '078-05-1120';
export const SSN_AD = '219-09-9999';

export function PersonalIdValidator(control: AbstractControl): ValidationErrors | null {
  const err = { invalidPersonalId: true };
  if (!control.value) {
    return null;
  }
  // first, make sure the length is sound
  if (isSSNNotMatchLength(control.value)) {
    return { invalidSSNLength: true };
  }
  // second, check for immediately known invalid ssn
  if (control.value === WOOLWORTH_SSN || control.value === SSN_AD) {
    return err;
  }
  // third, do a most basic check
  const area = /^9[0-9][0-9]|666|000$/.test(control.value.substring(0, 3)); // 900 - 999, 666, and 000 will never be valid
  const geo = /^00$/.test(control.value.substring(4, 6)); // 00 is never valid
  const serial = /^0000$/.test(control.value.substring(7)); // 0000 is never valid
  if (area || geo || serial) {
    return err;
  }
  return null;
}
